import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { API_URL } from '../../../config';
import { getCachedImageBlob } from '../utils/imageBlobCache';

const ImageLightbox = ({ url, name, onClose }) => {
    const [blobUrl, setBlobUrl] = useState('');

    useEffect(() => {
        let objectUrl = '';
        let cancelled = false;
        (async () => {
            if (!url) return;
            if (url.startsWith('blob:') || url.startsWith('data:')) {
                setBlobUrl(url);
                return;
            }
            const full = url.startsWith('http') ? url : `${API_URL}${url}`;
            const token = localStorage.getItem('token');
            const blob = await getCachedImageBlob(full, async () => {
                const res = await fetch(full, {
                    headers: token ? { Authorization: `Bearer ${token}` } : {},
                });
                if (!res.ok) throw new Error('Не удалось загрузить изображение');
                return res.blob();
            });
            objectUrl = URL.createObjectURL(blob);
            if (!cancelled) setBlobUrl(objectUrl);
        })();
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [url]);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') onClose?.();
        };
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener('keydown', onKey);
        };
    }, [onClose]);

    if (typeof document === 'undefined') return null;

    return createPortal(
        <div
            className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/90 p-2 sm:p-4"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-label={name || 'Просмотр изображения'}
        >
            {blobUrl ? (
                <img
                    src={blobUrl}
                    alt={name || ''}
                    className="max-h-full max-w-full object-contain"
                    onClick={(e) => e.stopPropagation()}
                />
            ) : (
                <div className="text-white">Загрузка…</div>
            )}
            <button
                type="button"
                onClick={onClose}
                className="absolute right-2 top-2 rounded-full bg-black/50 px-3 py-1.5 text-sm text-white/90 backdrop-blur-sm transition hover:bg-black/70"
            >
                Закрыть
            </button>
        </div>,
        document.body
    );
};

export default ImageLightbox;
